import { render, staticRenderFns } from "./SpinalStimulation.vue?vue&type=template&id=792e5318&scoped=true"
import script from "./SpinalStimulation.vue?vue&type=script&lang=js"
export * from "./SpinalStimulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792e5318",
  null
  
)

export default component.exports